import React, {Component} from "react"

class SideAd extends Component {

    render() {
        return (
            <div id="container-dd3e73a6c94f1124d476e3f8e1377121">

            </div>
        );
    }
}


export default SideAd;